import { Body, Dialog, Spacer } from '@spritz-finance/ui'
import { Row } from '../../components/Layout/Row'
import { Column } from '../../components/Layout/Column'
import React, { useContext, useState } from 'react'
import { Link, Networks, SpritzCardInfoGif, StyledContentWrapper } from './components'

const DialogState = React.createContext({ openDialog: () => {} })

export const SpritzCardInfoDialog: React.VFC<{ open: boolean; handleClose: () => void }> = ({
    open,
    handleClose,
}) => {
    return (
        <Dialog open={open} onClose={handleClose}>
            <Dialog.Content
                contentPadding={false}
                minWidth={560}
                style={{ minHeight: 200, maxWidth: '100%' }}
            >
                <Dialog.Title>SpritzCard</Dialog.Title>
                <StyledContentWrapper>
                    <Spacer height={16} />

                    <Row align="center">
                        <Column align="center">
                            <Spacer height={16} />
                            <Body.SmBold align="center">
                                Your SpritzCard is the fastest way to use crypto in the real world!
                            </Body.SmBold>
                        </Column>
                    </Row>

                    <Spacer height={32} />

                    <Row align="center">
                        <Networks />
                    </Row>

                    <Spacer height={16} />

                    <Row>
                        <Body.Reg size={16}>
                            You can load your SpritzCard with any token or stablecoin on our
                            supported networks!
                        </Body.Reg>
                    </Row>

                    <Spacer height={16} />

                    <Row align="center">
                        <SpritzCardInfoGif />
                    </Row>

                    <Spacer height={16} />
                    <Row>
                        <Body.Reg size={16}>
                            Your new SpritzCard is digital only. Use your SpritzCard IRL by
                            connecting it to a digital wallet such as Apple Pay or Google Wallet.
                            SpritzCard uses Visa—that's over 11 million merchants across the US!
                        </Body.Reg>
                    </Row>

                    <Spacer height={16} />
                    <Row>
                        <Body.Reg size={16}>
                            Learn more about how your SpritzCard works
                            <Link
                                href="https://help.spritz.finance/en/collections/3851967-spritz-card"
                                target="_blank"
                            >
                                here
                            </Link>
                        </Body.Reg>
                    </Row>

                    <Spacer height={24} />
                </StyledContentWrapper>
            </Dialog.Content>
        </Dialog>
    )
}

export const useSpritzCardInfoDialog = () => {
    return useContext(DialogState)
}

export const SpritzCardInfoDialogProvider: React.FC = ({ children }) => {
    const [open, setOpen] = useState<boolean>(false)

    const openDialog = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <DialogState.Provider value={{ openDialog }}>
            {children}
            <SpritzCardInfoDialog open={open} handleClose={handleClose} />
        </DialogState.Provider>
    )
}
